// https://code.amazon.com/packages/AWSSCMRFXService/blobs/mainline/--/configuration/brazil-config/global/AWSSCMRFXRequestClassDefinition.cfg
// Generic RFQRequest Class ID
export const RFQ_REQUEST_CLASS: string = "AWSRFQRequest";

// DCDivest/ISC RFQRequest Class ID with RFXProperty attributes specific to DCDivest business
export const RFQ_DCDIVEST_REQUEST_CLASS: string = "AWSRFQDCDivestRequest";

// IPS RFQRequest Class ID with RFXProperty attributes specific to IPS business
export const RFQ_IPS_REQUEST_CLASS: string = "AWSRFQIPSRequest";

export const RFQ_DCSP_REQUEST_CLASS: string = "AWSRFQDCSPRequest";

// https://code.amazon.com/packages/AWSSCMRFXService/blobs/mainline/--/configuration/brazil-config/global/AWSSCMRFXResponseClassDefinition.cfg
// Generic RFQResponse Class ID
export const RFQ_RESPONSE_CLASS: string = "AWSRFQResponse";

// DCDivest/ISC RFQResponse Class ID with RFXProperty attributes specific to DCDivest business
export const RFQ_DCDIVEST_RESPONSE_CLASS: string = "AWSRFQDCDivestResponse";

// IPS RFQResponse Class ID with RFXProperty attributes specific to IPS business
export const RFQ_IPS_RESPONSE_CLASS: string = "AWSRFQIPSResponse";

// DCSP RFQResponse Class ID
export const RFQ_DCSP_RESPONSE_CLASS: string = "AWSRFQDCSPResponse";

// https://code.amazon.com/packages/AWSSCMRFXService/blobs/mainline/--/configuration/brazil-config/global/AWSSCOSRFXLineItemClassDefinition.cfg
// Generic RFQLineItem Class ID
export const RFQ_LINEITEM_CLASS: string = "AWSRFQLineItem";

// DCDivest/ISC RFQLineItem Class ID with RFXProperty attributes specific to DCDivest business
export const RFQ_DCDIVEST_LINEITEM_CLASS: string = "AWSRFQDCDivestLineItem";

// IPS RFQLineItem Class ID with RFXProperty attributes specific to IPS business with EAM RFQ template
export const RFQ_IPS_LINEITEM_CLASS: string = "AWSRFQIPSLineItem";

// IPS EAM RFQLineItem Class ID with RFXProperty attributes specific to IPS business with EAM RFQ template
export const RFQ_IPS_EAM_LINEITEM_CLASS: string = "AWSRFQIPSEAMLineItem";

// IPS EAM Detail RFQLineItem Class ID with RFXProperty attributes specific to IPS business with EAM Detail template
export const RFQ_IPS_DETAIL_LINEITEM_CLASS: string = "AWSRFQIPSDetailLineItem";

// IPS non-EAM RFQLineItem Class ID with RFXProperty attributes specific to IPS business with non-EAM template
export const RFQ_IPS_NON_EAM_LINEITEM_CLASS: string = "AWSRFQIPSNonEAMLineItem";

// IPS Security Guard RFQLineItem Class ID with RFXProperty attributes specific to IPS business with Security Guard template
export const RFQ_IPS_SECURITY_GUARD_LINEITEM_CLASS: string = "AWSRFQIPSSecurityGuardLineItem";

// DCSP Templates RFQLineItem Class
export const RFQ_DCSP_DEFAULT_LINEITEM_CLASS: string = "AWSRFQDCSPDefaultLineItem";
export const RFQ_DCSP_GLOBAL_COMMISSIONING_BID_LINEITEM_CLASS: string = "AWSRFQDCSPGlobalCommissioningBidLineItem";
export const RFQ_DCSP_GLOBAL_DE_LINEITEM_CLASS: string = "AWSRFQDCSPGlobalDEBidLineItem";
export const RFQ_DCSP_GLOBAL_GC_BID_LINEITEM_CLASS: string = "AWSRFQDCSPGlobalGCBidLineItem";
export const RFQ_DCSP_GLOBAL_CONTROLS_BID_LINEITEM_CLASS: string = "AWSRFQDCSPGlobalControlsBidLineItem";

// Default primary key for RFQ line items (PAC and DCDivest)
export const RFQ_LINEITEM_DEFAULT_PRIMARY_KEY: string = "Line Id";

// Primary key for IPS EAM and IPS EAM Detail RFQ line items
export const RFQ_IPS_EAM_LINEITEM_PRIMARY_KEY: string = "No";

// Primary key for IPS Non EAM RFQ line items
export const RFQ_IPS_NON_EAM_LINEITEM_PRIMARY_KEY: string = "S.No."